import Vue from 'vue'
import App from './App.vue'
import router from "./router";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";

import "core-js/stable";
import "regenerator-runtime/runtime";

import "@mdi/font/css/materialdesignicons.css";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import 'material-design-icons-iconfont/dist/material-design-icons.css'

import VueSlickCarousel from "vue-slick-carousel";
Vue.use(VueSlickCarousel )

import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
import VueSweetalert2 from 'vue-sweetalert2';
Vue.use(VueSweetalert2);
Vue.use(require('vue-jalali-moment'));

Vue.use(VuePersianDatetimePicker, {
  name: 'custom-date-picker',
  props: {
    inputFormat: 'YYYY-MM-DD',
    format: 'jYYYY-jMM-jDD',
    editable: false,
    inputClass: 'form-control my-custom-class-name',
    placeholder: '',
    altFormat: 'YYYY-MM-DD',
    color: '#00FFFF',
    autoSubmit: true,
  }
});

const vuetifyOptions = {
  dark: true,
  icons: {
    iconfont: "mdi",
  },
};

Vue.use(Vuetify)

import { Plugin } from "vue-fragment";
Vue.use(Plugin);

Vue.config.productionTip = false

router.afterEach((to, from) => {
  Vue.nextTick(() => {
    document.title = to.meta.title || "";
  });
});

new Vue({
  router,
  render: (h) => h(App),
  vuetify: new Vuetify(vuetifyOptions),
}).$mount("#app");